import { Box, TextField } from '@mui/material'
import { GeolocateControl, Map, Marker, NavigationControl } from '@vis.gl/react-maplibre'
import { useController } from 'react-hook-form'
import StylesControl from '../maps/StylesControl'
import { useCallback, useEffect, useState } from 'react'

function MapInput ({ control, name, label, center, zoom, geoControlRef, isMobile }) {
  const [mapStyle, setMapStyle] = useState('openstreetmap')
  const mapKey = process.env.REACT_APP_API_KEY
  const handleSetStyle = style => setMapStyle(style)
  const [viewport, setViewport] = useState({})
  const [marker, setMarker] = useState(null)
  const {
    field
    , fieldState: { invalid, isTouched, isDirty }
    , formState: { touchedFields, dirtyFields }
  } = useController({
    name
    , defaultValue : ' '
    , control
    , rules        : { required: true }
  })

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(pos => {
      setViewport({
        ...viewport
        , latitude  : pos.coords.latitude
        , longitude : pos.coords.longitude
      })
    })
    setTimeout(() => { geoControlRef.current?.trigger()},100)
   
  }, [])

  useEffect(() => {
   const temporaryCoords = JSON.parse(localStorage.getItem('temporaryCoords'))
   if(temporaryCoords){
    setMarker({
      latitude: temporaryCoords.latitude,
      longitude: temporaryCoords.longitude
    })
   }
  },[marker])

  const onMapClick = useCallback(e => {
    const s = `${e.lngLat.lng} , ${e.lngLat.lat}`
    field.onChange(s)
    setMarker({
      latitude    : e.lngLat.lat
      , longitude : e.lngLat.lng
    })
    localStorage.setItem('temporaryCoords',JSON.stringify({latitude: e.lngLat.lat,longitude: e.lngLat.lng}))
  }, [])
  return (
    <Box display={'flex'} flexDirection={'column'} sx={{ height: !isMobile ? '75vh' : '75vh', width: '100%' }}>

    <Map
      reuseMaps={true}
      initialViewState={{
        viewport
      }}
      onLoad={() => {
      
        geoControlRef.current?.trigger()
      }}
      onClick={e => onMapClick(e)}
      style={{ cursor: 'none', display: 'inline' }}
      mapStyle={`https://api.maptiler.com/maps/${mapStyle}/style.json?key=${mapKey}`}
    >
      <NavigationControl position='top-right' />
      <GeolocateControl
      ref={geoControlRef}
      position={isMobile ? 'top-left' : 'top-right'}
      trackUserLocation={isMobile}
      showAccuracyCircle={isMobile}
      positionOptions={{ enableHighAccuracy: true }}
      />
      {marker && <Marker latitude={marker.latitude} longitude={marker.longitude}/>}
      <StylesControl handleSetStyle={handleSetStyle} position='bottom-right' />
    </Map>
    <TextField
      onChange={field.onChange} // send value to hook form
      onBlur={field.onBlur} // notify when input is touched/blur
      value={field.value} // input value
      name={field.name} // send down the input name
      inputRef={field.ref} // send input ref, so we can focus on input when error appear
      margin='normal'
      required
      disabled
      label={label}
      fullWidth
    />
    </Box>
  )
}

export default MapInput
